export default {
  component: () => import('./page.vue'),
  path: '/terminology/:active(risk|chart|heart)?',
  name: 'terminology',
  meta: {
    title: '术语解释',
  },
};
